import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function SliderDataBox(prop) {
    const { i18n } = useTranslation();
    return (
        <>
            <div className={`carousel--data ${i18n.language === "ar" ? "" : "carousel--data--En"} p-3 text-white`}>
                <h3>{prop.title}</h3>
                <p className="d-none d-md-block">{prop.description}</p>
                <Link type="button" to={prop.btnLink} className="w-100 text-center text-decoration-none btn-masar btn-dark-orange d-none d-sm-block">{prop.btnCaption}</Link>
            </div>
            <img
                src={prop.imgSrc}
                className="d-block w-100"
                alt={prop.imgAlt}
                loading={prop.id === 1 ? "eager" : "lazy"}
                fetchPriority={prop.id === 1 ? "high" : "auto"}
            />
        </>
    )
};